import { PRAYER_EDITIONS } from "./prayerEditions";
const renewal = PRAYER_EDITIONS["totus-tuus"];
export const MONTFORT_CARD = {
  audioId: "montfort-renewal",
  compact: true,
  eyebrow: "28 April · Optional memorial in the General Roman Calendar",
  title: "St. Louis-Marie de Montfort",
  subtitle: "To Jesus through Mary",
  image: { src: "/images/treasury/montfort.webp", alt: "St. Louis-Marie Grignion de Montfort", credit: "Traditional portrait · Public domain" },
  blocks: renewal.lines.map(([label, text]) => ({ label, text, italic: true })),
  source: { label: renewal.sourceLabel, url: renewal.sourceUrl },
  back: { eyebrow: "Totus Tuus", name: "St. Louis-Marie de Montfort", blessing: renewal.lines[0][1] },
  footer: "Theotokos · Mater Dei — Ad Iesum per Mariam",
};
export const isMontfortFeast = (feast) => /montfort/i.test(feast.name || "");